import * as d3 from "d3";

import { D3StaticChartOptimizedContainer, D3ChartRenderSettings } from "./D3StaticChartOptimizedContainer";

export interface RadialLevelChartProps {
    total: number;
    current: number;

    lineWidth?: number;
    chartCircleBackgound?: string;
    chartCircleForeground?: string;
}

export class RadialLevelChart extends D3StaticChartOptimizedContainer<RadialLevelChartProps> {
    renderChart(element: SVGSVGElement, props: Readonly<RadialLevelChartProps>, settings: D3ChartRenderSettings): void {
        const chart = d3.select(element);

        const lineWidth = props.lineWidth || 10;
        const innerRadius = settings.width / 2 - lineWidth;
        const outerRadius = settings.width / 2;

        const bgCircle = d3
            .arc()
            .startAngle(0)
            .endAngle(Math.PI * 2)
            .innerRadius(innerRadius)
            .outerRadius(outerRadius);

        const valueCircle = d3
            .arc()
            .startAngle(0)
            .endAngle(Math.PI * 2 * (props.current / (props.total || 1)))
            .innerRadius(innerRadius)
            .outerRadius(outerRadius)
            .cornerRadius(lineWidth / 2);

        chart
            .append("path")
            .attr("transform", `translate(${settings.width / 2}, ${settings.height / 2})`)
            .attr("fill", props.chartCircleBackgound || "rgba(26, 127, 179, 0.18)")
            .attr("d", bgCircle);

        chart
            .append("path")
            .attr("transform", `translate(${settings.width / 2}, ${settings.height / 2})`)
            .attr("fill", props.chartCircleForeground || "#1A7FB3")
            .attr("d", valueCircle);
    }
}
